<script lang="ts" setup>
import { computed } from 'vue';

import { StaffStore } from '@/services/StaffStore.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { useService } from '@nzyme/vue-ioc/useService.js';
import type { ChatStaffJoin } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import { useChatStaffJoin } from '@sigma/client/chat/useChatStaffJoin.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatStaffJoinCard from '@sigma/ui/chat/ChatStaffJoinCard.vue';

import chatCss from './chat.module.scss';
import * as l from './ChatStaffJoin.loc.js';

const props = defineProps(defineChatEventProps<ChatStaffJoin>());
const t = useTranslate();
const staffStore = useService(StaffStore);
const staff = useChatStaffJoin({
  staffId: () => props.event.staffId,
  load: staffId => staffStore.get(staffId),
});

// Role-aware copy: doctors get "Doctor joined", any other staff member gets the generic "Joined chat".
const caption = computed(() => (staff.isDoctor ? t(l.doctorJoined) : t(l.joinedChat)));
</script>

<template>
  <ChatEventWrapper
    tid="staff-join"
    :event="event"
    :class="chatCss.container"
  >
    <ChatStaffJoinCard
      :caption="caption"
      :title="staff.title"
      :first-name="staff.firstName"
      :last-name="staff.lastName"
      :loading="!staff.loaded"
    />
  </ChatEventWrapper>
</template>
